"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.filterAndSelectItemForInput = exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
/**
 * Selects an item if it exactly matches the only item in the filtered items list.
 *
 * @param {string} inputValue - autofill text value
 * @param {(string[]|Object[])} items - items list to filter on
 * @param {Function} filterItems - predicate for filtering an item (result of itemToString(item)) using an input text value
 * @param {Function} itemToString - converts items in items list to strings for filtering
 * @param {Function} selectItem - Downshift function to select an item as the value of the Select
 */
const filterAndSelectItemForInput = _ref => {
  let {
    inputValue,
    items,
    filterItems,
    itemToString,
    selectItem
  } = _ref;
  const filteredItems = (0, _filter.default)(items).call(items, item => filterItems(itemToString(item), inputValue));
  const newItem = filteredItems[0];
  if (filteredItems.length === 1 && itemToString(newItem) === inputValue) {
    selectItem(newItem);
  }
};
exports.filterAndSelectItemForInput = filterAndSelectItemForInput;
const SingleSelectTypeaheadInput = _ref2 => {
  let {
    placeholder,
    getInputProps,
    safeToggleMenu,
    maxLength,
    disabled,
    containsErrors,
    actionIconsPadding,
    enableAutoSelect,
    items,
    filterItems,
    itemToString,
    selectItem,
    onKeyDown,
    inputProps
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_styles.StyledInput, getInputProps({
    placeholder,
    onClick: safeToggleMenu,
    maxLength: maxLength,
    disabled: disabled,
    containsErrors: containsErrors,
    actionIconsPadding: actionIconsPadding,
    onChange: e => enableAutoSelect && filterAndSelectItemForInput({
      inputValue: e.target.value,
      items,
      filterItems,
      itemToString,
      selectItem
    }),
    onKeyDown: onKeyDown,
    ...inputProps
  }));
};
var _default = exports.default = SingleSelectTypeaheadInput;
SingleSelectTypeaheadInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleSelectTypeaheadInput"
};